import { chain, sortBy } from 'lodash';
import { auth as useAuthStore } from 'src/store/auth';

export default {
  clients: (state) => {
    const auth = useAuthStore();
    const { isManagerOrAdministrator } = auth;

    return sortBy(
      (isManagerOrAdministrator ? state.managedClients : state.loadedClients)
        .filter((client) => !client.isDeleted),
      'clientName',
    );
  },

  activeClients() {
    return chain(this.clients)
      .sortBy('clientName')
      .filter({ status: 'active' })
      .value();
  },

  regularClients() {
    return chain(this.clients)
      .sortBy('clientName')
      .filter({ type: 'client' })
      .value();
  },

  staffMembers() {
    return chain(this.clients)
      .sortBy('clientName')
      .filter({ type: 'staff' })
      .value();
  },
};
